module.exports = __webpack_public_path__ + "static/max_rec_white_logonew-e13ff6721740807d6e14246ca10b12a9.png";